import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para cualquier tipo de terapeuta?',
    a: 'Sí. El sistema fue diseñado para terapeutas holísticos en general. Medicina China, Flores de Bach, Registros Akáshicos, Constelaciones Familiares, Reflexología, Reiki y muchas otras disciplinas.'
  }, {
    q: '¿Necesito tener experiencia?',
    a: 'No. De hecho, cuanto antes desarrolles una presencia profesional, mejores resultados vas a obtener en el futuro.'
  }, {
    q: '¿Tengo que convertirme en influencer?',
    a: 'No. El objetivo no es que tengas miles de seguidores. El objetivo es que las personas correctas te encuentren y te consulten.'
  }, {
    q: '¿Recibo acceso inmediato?',
    a: 'Sí. Una vez acreditado el pago, recibís acceso inmediato a todo el material.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para probar todo el contenido. Si no es para vos, te devolvemos el dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-68">
      <div className="text-center mb-12" data-id="element-69">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-darkGreen" data-id="element-70">
          <span className="mr-3" data-id="element-71">❓</span> PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="space-y-4" data-id="element-72">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-aqua/25 bg-white/80" data-id="element-73">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-74">
              <span className="font-medium pr-8 text-brand-darkGreen text-[14px] md:text-base lg:text-lg" data-id="element-75">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-76" />
            </button>
            <AnimatePresence data-id="element-77">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-78">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-aqua/20 pt-4 bg-white/60 text-[13px] md:text-base leading-relaxed" data-id="element-79">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};